import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, } from '@/shared/components/Modal';
import { Button } from '@/shared/components/Button';
import { Field } from '@/shared/components/Field';
import { Textarea } from '@/shared/components/Textarea';
import { useToast } from '@/shared/components/Toast';
import { AppError } from '@/core/errors/AppError';
import { useCancelarReserva } from '@/data/hooks/useReservas';
export function CancelarReservaModal({ open, onOpenChange, reservaId, codigo }) {
    const [motivo, setMotivo] = useState('');
    const toast = useToast();
    const cancelar = useCancelarReserva();
    useEffect(() => {
        if (open)
            setMotivo('');
    }, [open]);
    if (!reservaId)
        return null;
    const onSubmit = (e) => {
        e.preventDefault();
        cancelar.mutate({ id: reservaId, motivo: motivo.trim() || undefined }, {
            onSuccess: () => {
                toast.exito('Reserva cancelada');
                onOpenChange(false);
            },
            onError: (err) => toast.error(err instanceof AppError ? err.mensaje : 'No pudimos cancelar la reserva.'),
        });
    };
    return (_jsx(Modal, { open: open, onOpenChange: onOpenChange, children: _jsxs(ModalContent, { size: "sm", children: [_jsx(ModalHeader, { titulo: "Cancelar reserva", descripcion: codigo ? `La reserva ${codigo} pasará a estado cancelada.` : undefined }), _jsxs("form", { onSubmit: onSubmit, children: [_jsx(ModalBody, { children: _jsx(Field, { label: "Motivo", htmlFor: "motivo", helper: "Opcional, pero recomendado.", children: _jsx(Textarea, { id: "motivo", rows: 3, value: motivo, onChange: (e) => setMotivo(e.target.value), autoFocus: true }) }) }), _jsxs(ModalFooter, { children: [_jsx(Button, { type: "button", variant: "secondary", onClick: () => onOpenChange(false), disabled: cancelar.isPending, children: "Volver" }), _jsx(Button, { type: "submit", variant: "danger", cargando: cancelar.isPending, children: "Cancelar reserva" })] })] })] }) }));
}
